export default {
  open_standalone: 'Öppet',
  closed_standalone: 'Stängt',

  open: 'Öppet',
  closed: 'Stängt',
  opening: 'Öppnar',
  closing: 'Stänger',
  yes_we_are: 'Ja, vi har',
  sorry_we_are: 'Tyvärr, vi har',
  twentyfourseven: '24/7',
  closing_tomorrow: 'Stänger imorgon',
  opening_tomorrow: 'Öppnar I morgon',
  at_x: 'kl. %x%',
  closing_x: 'Stänger %x%',
  opening_x: 'Öppnar %x%',

  monday: 'Måndag',
  tuesday: 'Tisdag',
  wednesday: 'Onsdag',
  thursday: 'Torsdag',
  friday: 'Fredag',
  saturday: 'Lördag',
  sunday: 'Söndag',

  businessHours: 'Öppetider'
};



// WEBPACK FOOTER //
// ./src/commons/translations/swe.js